// Translations for EN (default), 简体中文, Français.
// Brand identifiers 杀零牛 and SLN are intentionally never translated.
// Use {address} inside strings — replaced at render with the configured contract address.

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      tokenomics: "Tokenomics",
      howToBuy: "How to Buy",
      contract: "Contract",
      faq: "FAQ",
      community: "Community",
      buy: "BUY SLN",
      whitepaper: "Whitepaper",
      menu: "Menu",
      close: "Close",
    },
    hero: {
      kicker: "杀零 — The Zero Killer · BNB Smart Chain",
      tagline: "Killing Zeros. Building Community.",
      description:
        "SLN (杀零牛) is a community-driven meme coin on BNB Smart Chain, inspired by Chinese internet culture and the relentless spirit of “killing zeros”. No promises. No shortcuts. Just a herd that charges together.",
      buy: "BUY SLN",
      viewContract: "VIEW CONTRACT",
      joinCommunity: "JOIN COMMUNITY",
      badgeNetwork: "BNB Smart Chain · BEP-20",
      badgeChainId: "Chain ID 56",
      bullAlt: "Fierce red bull — the 杀零牛 (SLN) brand artwork",
    },
    marquee: "杀零牛 · KILLING ZEROS · SLN ON BNB SMART CHAIN · NO PROMISES — JUST HERD · ",
    contract: {
      label: "Official Contract",
      title: "SLN Contract Address",
      subtitle: "One address. Verify it everywhere before you trade.",
      copy: "COPY ADDRESS",
      copied: "Copied!",
      viewScan: "VIEW ON BSCSCAN",
      buy: "BUY SLN",
      warning: "Always verify the official contract address before trading.",
    },
    about: {
      kicker: "Manifesto",
      title: "What is 杀零牛?",
      chapters: [
        {
          t: "A community coin, born from internet culture",
          d: "杀零牛 (Sha Ling Niu) is a community-driven meme coin on BNB Smart Chain. It has no venture backers and no promised utility — its identity comes from the culture that created it and the community that carries it.",
        },
        {
          t: "What “killing zeros” (杀零) means",
          d: "In Chinese internet slang, 杀零 — “killing zeros” — describes the aspiration of watching zeros disappear as a number grows. It is a meme, a motto and a shared joke. It is not, and will never be presented as, a promise of performance.",
        },
        {
          t: "Why a fierce red bull",
          d: "Red is the colour of luck and celebration in Chinese culture. The bull stands for strength, determination and the bull-market spirit. Together they form the identity of the herd: aggressive in spirit, grounded in honesty.",
        },
        {
          t: "Why BNB Smart Chain",
          d: "BSC offers low transaction fees, fast confirmations and one of the largest retail communities in crypto. SLN is a standard BEP-20 token on chain ID 56, verifiable by anyone on BscScan.",
        },
        {
          t: "The community concept",
          d: "SLN belongs to its holders. The transaction tax is transparent and fixed: part is redistributed to holders, part feeds liquidity, part is burned and part funds the project wallet. Everything else is decided in the open, with the community.",
        },
      ],
    },
    tokenomics: {
      kicker: "Tokenomics",
      title: "5% In. 5% Out. Split Four Ways.",
      bannerTitle: "This is the distribution of the tax — not an initial allocation",
      bannerBody:
        "Every buy and every sell carries a 5% transaction tax. That collected tax is then divided: 20% to the funds recipient wallet, 20% to burn, 30% to holder distribution and 30% to liquidity — equal to 1.0%, 1.0%, 1.5% and 1.5% of each transaction respectively.",
      buyTax: "BUY TAX",
      sellTax: "SELL TAX",
      perTx: "of each transaction",
      distTitle: "Where the 5% tax goes",
      shareOfTax: "of collected tax",
      items: [
        { name: "Funds Recipient Wallet", desc: "Project wallet that funds ecosystem operations and growth." },
        { name: "Token Burn", desc: "Sent to a burn address, permanently reducing supply over time." },
        { name: "Holder Distribution", desc: "Redistributed proportionally to SLN holders." },
        { name: "Liquidity", desc: "Routed to the liquidity pool to support trading." },
      ],
      note: "Percentages on this page describe how the 5% transaction tax is distributed. They are not an initial token allocation, and no allocation figures are published here unless officially confirmed.",
    },
    steps: {
      kicker: "How to Buy",
      title: "Six Steps. Zero Blind Trust.",
      list: [
        {
          t: "Install a BNB Smart Chain compatible wallet",
          d: "Choose a reputable wallet that supports BSC (BEP-20) tokens. Back up your recovery phrase offline — and never share it with anyone.",
        },
        {
          t: "Acquire BNB",
          d: "You need BNB for network fees and trading. Buy it on an exchange and withdraw it to your wallet on the BSC network.",
        },
        {
          t: "Open the official trading link",
          d: "Use only the official trading link published by the project. Bookmark it and beware of imitation sites.",
        },
        {
          t: "Verify the SLN contract address",
          d: "Compare the token contract character by character with the official address shown on this site before any trade.",
        },
        {
          t: "Connect your wallet on the third-party DEX",
          d: "If you choose to trade, connect your wallet directly on the third-party DEX. This website never asks you to connect a wallet or sign anything.",
        },
        {
          t: "Review transaction details before confirming",
          d: "Check the token, amount, slippage and the 5% tax. Transactions on BSC are irreversible once confirmed.",
        },
      ],
      warnTitle: "Security first",
      warnBody:
        "The SLN project will never ask for your seed phrase, private key or wallet recovery phrase. Anyone who does is a scammer. Always verify the contract address and the URL before trading.",
    },
    live: {
      kicker: "On-Chain",
      title: "Live Token Information",
      unavailable: "Data unavailable",
      loading: "Reading chain…",
      metrics: {
        network: "Network",
        contract: "Contract",
        symbol: "Token Symbol",
        decimals: "Decimals",
        totalSupply: "Total Supply",
        burned: "Burned (dead wallet)",
        price: "Price",
        marketCap: "Market Cap",
      },
      note: "On-chain fields are read directly from public BNB Smart Chain RPC endpoints. Price, market capitalization, volume and holder counts are intentionally shown as “Data unavailable” — no reliable public source is configured, and this site will never display fabricated numbers.",
    },
    roadmap: {
      kicker: "Roadmap",
      title: "The Charge Ahead",
      phases: [
        {
          t: "Launch & Ignition",
          d: "Token launch on BNB Smart Chain, initial community formation and opening of the official channels.",
        },
        {
          t: "Community Expansion",
          d: "Growing the herd: content, memes, community events and wider ecosystem visibility.",
        },
        {
          t: "Tracking & Integrations",
          d: "Applications to tracking platforms and integrations that improve transparency and access.",
        },
        {
          t: "Community-Driven Development",
          d: "Future direction shaped by the community. Milestones are announced when completed — never before.",
        },
      ],
    },
    community: {
      kicker: "Community",
      title: "Join the Herd",
      pending:
        "Official social channels will appear here once they are announced. Until then, beware of fake groups and impersonators.",
      cards: {
        x: { name: "X / Twitter", desc: "Announcements and project updates." },
        telegram: { name: "Telegram", desc: "The herd's main gathering place." },
        fourMeme: { name: "Four.meme", desc: "Token page on the Four.meme platform." },
        bscscan: { name: "BscScan", desc: "Verify the contract and every transaction on-chain." },
      },
    },
    faq: {
      kicker: "FAQ",
      title: "Questions, Answered Straight",
      items: [
        {
          q: "What is SLN?",
          a: "SLN (杀零牛, Sha Ling Niu) is a community-driven meme coin on BNB Smart Chain, inspired by Chinese internet culture and the concept of “killing zeros”.",
        },
        {
          q: "What blockchain is SLN on?",
          a: "SLN is a BEP-20 token on BNB Smart Chain (chain ID 56).",
        },
        {
          q: "What is the official contract address?",
          a: "The official SLN contract address is {address}. Always verify it on BscScan before trading.",
        },
        {
          q: "What are the buy and sell taxes?",
          a: "Both the buy tax and the sell tax are 5% per transaction.",
        },
        {
          q: "How is the transaction tax distributed?",
          a: "Of the collected 5% tax: 20% goes to the funds recipient wallet, 20% is burned, 30% is distributed to holders and 30% goes to liquidity. That equals 1.0%, 1.0%, 1.5% and 1.5% of each transaction respectively.",
        },
        {
          q: "What does “killing zeros” mean?",
          a: "杀零 (“killing zeros”) is Chinese internet slang describing the aspiration of watching zeros disappear as a number grows. It is a cultural meme and community motto — not a promise of performance.",
        },
        {
          q: "Where can SLN be traded?",
          a: "SLN trades on BNB Smart Chain decentralised exchanges. Use only the official trading links published by the project, and verify the contract address first.",
        },
        {
          q: "How can I verify the token contract?",
          a: "Open the contract on BscScan and compare the address character by character with the one on this site. Check the token name, symbol and transaction history before trading.",
        },
        {
          q: "Does SLN guarantee financial returns?",
          a: "No. Cryptocurrencies are highly volatile and involve significant risk. SLN makes no promise of profit or returns of any kind, and nothing on this website is financial advice.",
        },
      ],
    },
    risk: {
      title: "Risk Disclosure",
      body1:
        "Cryptocurrency assets can be highly volatile, and you may lose the full value of your purchase. Always independently verify contract addresses and transaction details before trading, and never trade with funds you cannot afford to lose.",
      body2:
        "Nothing on this website constitutes financial, investment or legal advice. No financial return is promised or guaranteed. The SLN team will never ask for your seed phrase, private key or recovery phrase.",
    },
    footer: {
      tagline: "Killing Zeros. Building Community.",
      contractLabel: "Contract (BEP-20)",
      explore: "Explore",
      riskLine:
        "Cryptocurrencies are high-risk assets. Nothing on this site is financial advice. No returns are guaranteed.",
      rights: "All rights reserved.",
    },
  },

  zh: {
    nav: {
      home: "首页",
      about: "关于",
      tokenomics: "代币经济",
      howToBuy: "如何购买",
      contract: "合约",
      faq: "常见问题",
      community: "社区",
      buy: "购买 SLN",
      whitepaper: "白皮书",
      menu: "菜单",
      close: "关闭",
    },
    hero: {
      kicker: "杀零 — 零的猎手 · BNB 智能链",
      tagline: "杀零前行,共建社区。",
      description:
        "SLN(杀零牛)是 BNB 智能链上由社区驱动的迷因币,灵感源自中国网络文化与“杀零”精神。不承诺,不夸大,只有一群并肩冲锋的牛。",
      buy: "购买 SLN",
      viewContract: "查看合约",
      joinCommunity: "加入社区",
      badgeNetwork: "BNB 智能链 · BEP-20",
      badgeChainId: "链 ID 56",
      bullAlt: "凶猛红牛 — 杀零牛(SLN)品牌视觉",
    },
    marquee: "杀零牛 · 杀零前行 · SLN 登陆 BNB 智能链 · 不承诺 — 只有牛群 · ",
    contract: {
      label: "官方合约",
      title: "SLN 合约地址",
      subtitle: "唯一地址,交易前请处处核对。",
      copy: "复制地址",
      copied: "已复制!",
      viewScan: "在 BSCSCAN 查看",
      buy: "购买 SLN",
      warning: "交易前请务必核实官方合约地址。",
    },
    about: {
      kicker: "宣言",
      title: "什么是杀零牛?",
      chapters: [
        {
          t: "诞生于网络文化的社区币",
          d: "杀零牛(Sha Ling Niu)是 BNB 智能链上由社区驱动的迷因币。没有风投背书,也不虚构用途——它的身份来自孕育它的文化和承载它的社区。",
        },
        {
          t: "“杀零”是什么意思",
          d: "在中国网络俚语中,“杀零”表达了看着数字增长、零一个个消失的愿望。它是一个梗、一句口号、一个共同的玩笑,从来不是也永远不会被当作对收益的承诺。",
        },
        {
          t: "为什么是凶猛的红牛",
          d: "红色在中国文化中象征好运与喜庆,公牛代表力量、决心与牛市精神。二者合一,就是牛群的身份:气势凶猛,为人诚实。",
        },
        {
          t: "为什么选择 BNB 智能链",
          d: "BSC 手续费低、确认快,拥有加密世界最大的散户社区之一。SLN 是链 ID 56 上的标准 BEP-20 代币,任何人都可以在 BscScan 上验证。",
        },
        {
          t: "社区理念",
          d: "SLN 属于持有者。交易税透明且固定:一部分分配给持有者,一部分注入流动性,一部分销毁,一部分进入项目钱包。其余一切,都与社区公开决定。",
        },
      ],
    },
    tokenomics: {
      kicker: "代币经济",
      title: "买 5%,卖 5%,四向分流。",
      bannerTitle: "以下是税收的分配方式 — 而非初始代币分配",
      bannerBody:
        "每笔买入和卖出收取 5% 的交易税。所收税款按以下方式分配:20% 进入资金接收钱包,20% 销毁,30% 分配给持有者,30% 注入流动性——分别相当于每笔交易的 1.0%、1.0%、1.5% 和 1.5%。",
      buyTax: "买入税",
      sellTax: "卖出税",
      perTx: "每笔交易",
      distTitle: "5% 税款去向",
      shareOfTax: "占所收税款",
      items: [
        { name: "资金接收钱包", desc: "用于生态运营与发展的项目钱包。" },
        { name: "代币销毁", desc: "发送至销毁地址,随时间永久减少供应。" },
        { name: "持有者分配", desc: "按比例重新分配给 SLN 持有者。" },
        { name: "流动性", desc: "注入流动性池以支持交易。" },
      ],
      note: "本页百分比描述的是 5% 交易税的分配方式,并非初始代币分配。除非官方确认,本站不会公布任何分配数据。",
    },
    steps: {
      kicker: "如何购买",
      title: "六个步骤,零盲信。",
      list: [
        {
          t: "安装兼容 BNB 智能链的钱包",
          d: "选择支持 BSC(BEP-20)代币的知名钱包。将助记词离线备份,绝不与任何人分享。",
        },
        {
          t: "获取 BNB",
          d: "您需要 BNB 支付网络手续费并进行交易。在交易所购买后,通过 BSC 网络提现到您的钱包。",
        },
        {
          t: "打开官方交易链接",
          d: "仅使用项目方公布的官方交易链接。请收藏该链接,谨防仿冒网站。",
        },
        {
          t: "核对 SLN 合约地址",
          d: "交易前,请逐字符核对代币合约与本站显示的官方地址是否一致。",
        },
        {
          t: "在第三方 DEX 上连接钱包",
          d: "如果您选择交易,请直接在第三方 DEX 上连接钱包。本网站绝不会要求您连接钱包或签署任何内容。",
        },
        {
          t: "确认前检查交易详情",
          d: "核对代币、数量、滑点与 5% 税费。BSC 上的交易一经确认即不可撤销。",
        },
      ],
      warnTitle: "安全第一",
      warnBody:
        "SLN 项目方绝不会索取您的助记词、私钥或钱包恢复短语。任何这样做的人都是骗子。交易前请务必核实合约地址与网址。",
    },
    live: {
      kicker: "链上数据",
      title: "实时代币信息",
      unavailable: "暂无数据",
      loading: "正在读取链上数据…",
      metrics: {
        network: "网络",
        contract: "合约",
        symbol: "代币符号",
        decimals: "小数位",
        totalSupply: "总供应量",
        burned: "已销毁(销毁地址)",
        price: "价格",
        marketCap: "市值",
      },
      note: "链上字段直接读取自 BNB 智能链公共 RPC 节点。价格、市值、成交量与持有者数量刻意显示为“暂无数据”——本站未接入可靠数据源,也绝不会展示捏造的数字。",
    },
    roadmap: {
      kicker: "路线图",
      title: "冲锋之路",
      phases: [
        {
          t: "启动与点燃",
          d: "代币在 BNB 智能链上线,初始社区形成,官方渠道开通。",
        },
        {
          t: "社区扩张",
          d: "壮大牛群:内容、梗图、社区活动,提升生态可见度。",
        },
        {
          t: "收录与集成",
          d: "申请收录至各追踪平台,集成提升透明度与可及性的工具。",
        },
        {
          t: "社区驱动开发",
          d: "未来方向由社区决定。里程碑完成后才会公布——绝不提前。",
        },
      ],
    },
    community: {
      kicker: "社区",
      title: "加入牛群",
      pending: "官方社交渠道公布后将在此展示。在此之前,请谨防假冒群组与冒充者。",
      cards: {
        x: { name: "X / Twitter", desc: "公告与项目动态。" },
        telegram: { name: "Telegram", desc: "牛群的主要聚集地。" },
        fourMeme: { name: "Four.meme", desc: "Four.meme 平台上的代币页面。" },
        bscscan: { name: "BscScan", desc: "在链上验证合约与每一笔交易。" },
      },
    },
    faq: {
      kicker: "常见问题",
      title: "有问直答",
      items: [
        {
          q: "什么是 SLN?",
          a: "SLN(杀零牛,Sha Ling Niu)是 BNB 智能链上由社区驱动的迷因币,灵感源自中国网络文化与“杀零”的概念。",
        },
        {
          q: "SLN 在哪条区块链上?",
          a: "SLN 是 BNB 智能链(链 ID 56)上的 BEP-20 代币。",
        },
        {
          q: "官方合约地址是什么?",
          a: "SLN 官方合约地址为 {address}。交易前请务必在 BscScan 上核实。",
        },
        {
          q: "买入税和卖出税是多少?",
          a: "买入税与卖出税均为每笔交易 5%。",
        },
        {
          q: "交易税如何分配?",
          a: "所收 5% 税款中:20% 进入资金接收钱包,20% 销毁,30% 分配给持有者,30% 注入流动性,分别相当于每笔交易的 1.0%、1.0%、1.5% 和 1.5%。",
        },
        {
          q: "“杀零”是什么意思?",
          a: "“杀零”是中国网络俚语,形容看着数字增长、零一个个消失的愿望。它是一个文化梗和社区口号,而非对收益的承诺。",
        },
        {
          q: "在哪里可以交易 SLN?",
          a: "SLN 在 BNB 智能链的去中心化交易所交易。请仅使用项目方公布的官方链接,并先核实合约地址。",
        },
        {
          q: "如何验证代币合约?",
          a: "在 BscScan 上打开合约,与本站地址逐字符比对。交易前请检查代币名称、符号与交易记录。",
        },
        {
          q: "SLN 保证财务回报吗?",
          a: "不保证。加密货币波动性极高,风险重大。SLN 不作任何形式的盈利或回报承诺,本网站的任何内容均不构成财务建议。",
        },
      ],
    },
    risk: {
      title: "风险披露",
      body1:
        "加密资产可能高度波动,您可能损失全部投入。交易前请务必独立核实合约地址与交易详情,切勿投入无法承受损失的资金。",
      body2:
        "本网站的任何内容均不构成财务、投资或法律建议。本站不承诺也不保证任何财务回报。SLN 团队绝不会索取您的助记词、私钥或恢复短语。",
    },
    footer: {
      tagline: "杀零前行,共建社区。",
      contractLabel: "合约地址(BEP-20)",
      explore: "导航",
      riskLine: "加密货币属于高风险资产。本站内容不构成财务建议,不保证任何回报。",
      rights: "版权所有。",
    },
  },

  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      tokenomics: "Tokenomics",
      howToBuy: "Acheter",
      contract: "Contrat",
      faq: "FAQ",
      community: "Communauté",
      buy: "ACHETER SLN",
      whitepaper: "Whitepaper",
      menu: "Menu",
      close: "Fermer",
    },
    hero: {
      kicker: "杀零 — Le tueur de zéros · BNB Smart Chain",
      tagline: "Killing Zeros. Building Community.",
      description:
        "SLN (杀零牛) est un meme coin communautaire sur BNB Smart Chain, inspiré de la culture internet chinoise et de l'esprit du « killing zeros ». Aucune promesse. Aucun raccourci. Juste un troupeau qui charge ensemble.",
      buy: "ACHETER SLN",
      viewContract: "VOIR LE CONTRAT",
      joinCommunity: "REJOINDRE LA COMMUNAUTÉ",
      badgeNetwork: "BNB Smart Chain · BEP-20",
      badgeChainId: "Chain ID 56",
      bullAlt: "Taureau rouge féroce — visuel de marque 杀零牛 (SLN)",
    },
    marquee: "杀零牛 · KILLING ZEROS · SLN SUR BNB SMART CHAIN · AUCUNE PROMESSE — JUSTE LE TROUPEAU · ",
    contract: {
      label: "Contrat officiel",
      title: "Adresse du contrat SLN",
      subtitle: "Une seule adresse. Vérifiez-la partout avant de trader.",
      copy: "COPIER L'ADRESSE",
      copied: "Copié !",
      viewScan: "VOIR SUR BSCSCAN",
      buy: "ACHETER SLN",
      warning: "Vérifiez toujours l'adresse officielle du contrat avant de trader.",
    },
    about: {
      kicker: "Manifeste",
      title: "Qu'est-ce que 杀零牛 ?",
      chapters: [
        {
          t: "Un coin communautaire, né de la culture internet",
          d: "杀零牛 (Sha Ling Niu) est un meme coin communautaire sur BNB Smart Chain. Sans investisseurs capital-risque ni utilité fictive — son identité vient de la culture qui l'a créé et de la communauté qui le porte.",
        },
        {
          t: "Ce que signifie « killing zeros » (杀零)",
          d: "Dans l'argot internet chinois, 杀零 — « tuer des zéros » — décrit l'aspiration à voir les zéros disparaître à mesure qu'un nombre grandit. C'est un meme, une devise et une blague partagée. Ce n'est pas, et ce ne sera jamais présenté comme, une promesse de performance.",
        },
        {
          t: "Pourquoi un taureau rouge féroce",
          d: "Le rouge est la couleur de la chance et de la fête dans la culture chinoise. Le taureau incarne la force, la détermination et l'esprit du bull market. Ensemble, ils forment l'identité du troupeau : féroce en apparence, honnête en substance.",
        },
        {
          t: "Pourquoi BNB Smart Chain",
          d: "BSC offre des frais réduits, des confirmations rapides et l'une des plus grandes communautés crypto. SLN est un token BEP-20 standard sur la chaîne 56, vérifiable par tous sur BscScan.",
        },
        {
          t: "Le concept communautaire",
          d: "SLN appartient à ses détenteurs. La taxe de transaction est transparente et fixe : une partie est redistribuée aux détenteurs, une partie alimente la liquidité, une partie est brûlée et une partie finance le portefeuille du projet. Tout le reste se décide ouvertement, avec la communauté.",
        },
      ],
    },
    tokenomics: {
      kicker: "Tokenomics",
      title: "5 % à l'achat. 5 % à la vente. Quatre voies.",
      bannerTitle: "Voici la répartition de la taxe — pas une allocation initiale",
      bannerBody:
        "Chaque achat et chaque vente supporte une taxe de 5 %. Cette taxe collectée est ensuite répartie : 20 % vers le portefeuille bénéficiaire, 20 % vers le burn, 30 % vers la redistribution aux détenteurs et 30 % vers la liquidité — soit 1,0 %, 1,0 %, 1,5 % et 1,5 % de chaque transaction.",
      buyTax: "TAXE D'ACHAT",
      sellTax: "TAXE DE VENTE",
      perTx: "de chaque transaction",
      distTitle: "Où va la taxe de 5 %",
      shareOfTax: "de la taxe collectée",
      items: [
        { name: "Portefeuille bénéficiaire", desc: "Portefeuille du projet finançant les opérations et la croissance de l'écosystème." },
        { name: "Burn de tokens", desc: "Envoyés vers une adresse de burn, réduisant l'offre de façon permanente." },
        { name: "Redistribution aux détenteurs", desc: "Redistribués proportionnellement aux détenteurs de SLN." },
        { name: "Liquidité", desc: "Dirigés vers le pool de liquidité pour soutenir les échanges." },
      ],
      note: "Les pourcentages de cette page décrivent la répartition de la taxe de transaction de 5 %. Il ne s'agit pas d'une allocation initiale de tokens, et aucun chiffre d'allocation n'est publié ici sans confirmation officielle.",
    },
    steps: {
      kicker: "Comment acheter",
      title: "Six étapes. Zéro confiance aveugle.",
      list: [
        {
          t: "Installez un wallet compatible BNB Smart Chain",
          d: "Choisissez un wallet réputé compatible avec les tokens BSC (BEP-20). Sauvegardez votre phrase de récupération hors ligne — et ne la partagez jamais.",
        },
        {
          t: "Obtenez du BNB",
          d: "Il vous faut du BNB pour les frais réseau et le trading. Achetez-en sur une plateforme d'échange et retirez-le vers votre wallet sur le réseau BSC.",
        },
        {
          t: "Ouvrez le lien de trading officiel",
          d: "Utilisez uniquement le lien officiel publié par le projet. Ajoutez-le à vos favoris et méfiez-vous des imitations.",
        },
        {
          t: "Vérifiez l'adresse du contrat SLN",
          d: "Comparez le contrat caractère par caractère avec l'adresse officielle affichée sur ce site avant toute transaction.",
        },
        {
          t: "Connectez votre wallet sur le DEX tiers",
          d: "Si vous choisissez de trader, connectez votre wallet directement sur le DEX tiers. Ce site ne vous demandera jamais de connecter un wallet ni de signer quoi que ce soit.",
        },
        {
          t: "Vérifiez les détails avant de confirmer",
          d: "Contrôlez le token, le montant, le slippage et la taxe de 5 %. Les transactions sur BSC sont irréversibles une fois confirmées.",
        },
      ],
      warnTitle: "La sécurité d'abord",
      warnBody:
        "Le projet SLN ne vous demandera jamais votre seed phrase, votre clé privée ni votre phrase de récupération. Quiconque le fait est un escroc. Vérifiez toujours l'adresse du contrat et l'URL avant de trader.",
    },
    live: {
      kicker: "On-chain",
      title: "Informations du token en direct",
      unavailable: "Données indisponibles",
      loading: "Lecture de la chaîne…",
      metrics: {
        network: "Réseau",
        contract: "Contrat",
        symbol: "Symbole",
        decimals: "Décimales",
        totalSupply: "Offre totale",
        burned: "Brûlés (adresse dead)",
        price: "Prix",
        marketCap: "Capitalisation",
      },
      note: "Les champs on-chain sont lus directement depuis les RPC publics de BNB Smart Chain. Le prix, la capitalisation, le volume et le nombre de détenteurs sont volontairement affichés comme « Données indisponibles » — aucune source publique fiable n'est configurée, et ce site n'affichera jamais de chiffres inventés.",
    },
    roadmap: {
      kicker: "Feuille de route",
      title: "La charge à venir",
      phases: [
        {
          t: "Lancement & ignition",
          d: "Lancement du token sur BNB Smart Chain, formation de la communauté initiale et ouverture des canaux officiels.",
        },
        {
          t: "Expansion communautaire",
          d: "Faire grandir le troupeau : contenu, memes, événements communautaires et visibilité dans l'écosystème.",
        },
        {
          t: "Référencement & intégrations",
          d: "Candidatures aux plateformes de suivi et intégrations améliorant la transparence et l'accès.",
        },
        {
          t: "Développement communautaire",
          d: "La direction future est décidée par la communauté. Les jalons sont annoncés une fois terminés — jamais avant.",
        },
      ],
    },
    community: {
      kicker: "Communauté",
      title: "Rejoignez le troupeau",
      pending:
        "Les canaux sociaux officiels apparaîtront ici dès leur annonce. D'ici là, méfiez-vous des faux groupes et des usurpateurs.",
      cards: {
        x: { name: "X / Twitter", desc: "Annonces et nouvelles du projet." },
        telegram: { name: "Telegram", desc: "Le lieu de rassemblement du troupeau." },
        fourMeme: { name: "Four.meme", desc: "Page du token sur la plateforme Four.meme." },
        bscscan: { name: "BscScan", desc: "Vérifiez le contrat et chaque transaction on-chain." },
      },
    },
    faq: {
      kicker: "FAQ",
      title: "Des réponses franches",
      items: [
        {
          q: "Qu'est-ce que SLN ?",
          a: "SLN (杀零牛, Sha Ling Niu) est un meme coin communautaire sur BNB Smart Chain, inspiré de la culture internet chinoise et du concept de « killing zeros ».",
        },
        {
          q: "Sur quelle blockchain est SLN ?",
          a: "SLN est un token BEP-20 sur BNB Smart Chain (chain ID 56).",
        },
        {
          q: "Quelle est l'adresse officielle du contrat ?",
          a: "L'adresse officielle du contrat SLN est {address}. Vérifiez-la toujours sur BscScan avant de trader.",
        },
        {
          q: "Quelles sont les taxes d'achat et de vente ?",
          a: "La taxe d'achat comme la taxe de vente sont de 5 % par transaction.",
        },
        {
          q: "Comment la taxe de transaction est-elle répartie ?",
          a: "Sur les 5 % collectés : 20 % vont au portefeuille bénéficiaire, 20 % sont brûlés, 30 % sont redistribués aux détenteurs et 30 % vont à la liquidité. Soit 1,0 %, 1,0 %, 1,5 % et 1,5 % de chaque transaction.",
        },
        {
          q: "Que signifie « killing zeros » ?",
          a: "杀零 (« tuer des zéros ») est une expression de l'argot internet chinois décrivant l'aspiration à voir les zéros disparaître à mesure qu'un nombre grandit. C'est un meme culturel et une devise communautaire — pas une promesse de performance.",
        },
        {
          q: "Où peut-on trader SLN ?",
          a: "SLN s'échange sur des exchanges décentralisés de BNB Smart Chain. N'utilisez que les liens officiels publiés par le projet et vérifiez d'abord l'adresse du contrat.",
        },
        {
          q: "Comment vérifier le contrat du token ?",
          a: "Ouvrez le contrat sur BscScan et comparez l'adresse caractère par caractère avec celle de ce site. Vérifiez le nom du token, son symbole et l'historique des transactions avant de trader.",
        },
        {
          q: "SLN garantit-il des rendements financiers ?",
          a: "Non. Les cryptomonnaies sont très volatiles et comportent des risques importants. SLN ne promet aucun profit ni rendement d'aucune sorte, et rien sur ce site ne constitue un conseil financier.",
        },
      ],
    },
    risk: {
      title: "Avertissement sur les risques",
      body1:
        "Les actifs crypto peuvent être très volatils et vous pouvez perdre l'intégralité de votre investissement. Vérifiez toujours de manière indépendante les adresses de contrat et les détails des transactions avant de trader, et n'investissez jamais des fonds que vous ne pouvez pas vous permettre de perdre.",
      body2:
        "Rien sur ce site ne constitue un conseil financier, d'investissement ou juridique. Aucun rendement financier n'est promis ni garanti. L'équipe SLN ne vous demandera jamais votre seed phrase, votre clé privée ni votre phrase de récupération.",
    },
    footer: {
      tagline: "Killing Zeros. Building Community.",
      contractLabel: "Contrat (BEP-20)",
      explore: "Explorer",
      riskLine:
        "Les cryptomonnaies sont des actifs à haut risque. Rien sur ce site ne constitue un conseil financier. Aucun rendement n'est garanti.",
      rights: "Tous droits réservés.",
    },
  },
};

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "zh", label: "中文", name: "简体中文" },
  { code: "fr", label: "FR", name: "Français" },
];
